module.exports = __webpack_public_path__ + "img/Dankrad Feist.b15787f0.jpg";